
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_gfwv3_pbpwp_9",
  "horizontal": "awsui_horizontal_gfwv3_pbpwp_12",
  "vertical": "awsui_vertical_gfwv3_pbpwp_18",
  "list": "awsui_list_gfwv3_pbpwp_23",
  "grid": "awsui_grid_gfwv3_pbpwp_42",
  "list-item": "awsui_list-item_gfwv3_pbpwp_54",
  "toggle-container-inline": "awsui_toggle-container-inline_gfwv3_pbpwp_61",
  "toggle": "awsui_toggle_gfwv3_pbpwp_61",
  "description": "awsui_description_gfwv3_pbpwp_154",
  "separator": "awsui_separator_gfwv3_pbpwp_158"
};
  